export const mapEventNameToText = (eventName: string, resources: any): string => {
    //simulate if eventName is null or undefined to produce error
    if (!eventName) {
        return resources.orderDetailsEventNameUnknown;
    }

    switch (eventName.toLowerCase()) {
        case 'completed':
            return resources.orderDetailsEventNameCompleted;
        case 'ordered':
            return resources.orderDetailsEventNameOrdered;
        case 'in transit':
            return resources.orderDetailsEventNameInTransit;
        case 'planned':
            return resources.orderDetailsEventNamePlanned;
        case 'active':
            return resources.orderDetailsEventNameActive;
        case 'arrival':
            return resources.orderDetailsEventNameArrival;
        case 'container_loading':
            return resources.orderDetailsEventNameLoading;
        case 'departure':
            return resources.orderDetailsEventNameDeparture;
        case 'confirmed':
            return resources.orderDetailsEventNameConfirmed;
        case 'self_pickup':
            return resources.orderDetailsEventNameSelfPickup;
        default:
            return resources.orderDetailsEventNameUnknown;
    }
};
